import { AreaField } from "@/components/ui/autoform/components/custom/AreaField";
import { CustomObjectWrapper } from "@/components/ui/autoform/components/custom/CustomObjectWrapper";
import { EnrichmentStatusField } from "@/components/ui/autoform/components/custom/EnrichmentStatusField";
import { EnrichmentSummaryField } from "@/components/ui/autoform/components/custom/EnrichmentSummaryField";
import { FeaturesField } from "@/components/ui/autoform/components/custom/FeaturesField";
import { HiddenField } from "@/components/ui/autoform/components/custom/HiddenField";
import { MediaField } from "@/components/ui/autoform/components/custom/MediaField";
import { RemoteMultiSelectField } from "@/components/ui/autoform/components/custom/RemoteMultiSelectField";
import { RemoteSelectField } from "@/components/ui/autoform/components/custom/RemoteSelectField";
import { TagListField } from "@/components/ui/autoform/components/custom/TagListField";
import { TextAreaField } from "@/components/ui/autoform/components/custom/TextAreaField";

import { DateField } from "../DateField";
import { DateTimeField } from "./DateTimeField";
import GenresField from "./GenresField";

export const injectCustomAutoFormComponents = ({
  formComponents,
  uiComponents,
}: {
  formComponents?: any;
  uiComponents?: any;
} = {}) => {
  return {
    formComponents: {
      area: AreaField,
      remoteSelect: RemoteSelectField,
      remoteMultiSelect: RemoteMultiSelectField,
      textarea: TextAreaField,
      media: MediaField,
      date: DateField,
      datetime: DateTimeField,
      genres: GenresField,
      tagList: TagListField,
      hidden: HiddenField,
      enrichmentStatus: EnrichmentStatusField,
      features: FeaturesField,
      enrichmentSummary: EnrichmentSummaryField,
      ...formComponents,
    },
    uiComponents: {
      ObjectWrapper: CustomObjectWrapper,
      ...uiComponents,
    },
  };
};
